var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossedbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0999 23.1743C38.3291 27.7615 41.4435 31.5679 45.6456 33.6172C46.7542 34.1672 47.5574 35.1543 47.8754 36.341C48.4748 38.5782 47.1931 40.8718 45.018 41.4546L7.82715 51.4199C7.07998 51.6201 6.3232 51.5928 5.62726 51.38L36.4095 20.5978L37.0999 23.1743ZM34.0169 13.2274L4.69487 42.5495C6.21424 39.1579 6.52952 35.3082 5.54388 31.6297L3.8123 25.1673C1.62672 17.0107 5.70736 8.6802 13.0383 5.50356L12.3675 2.99984C12.024 1.71806 12.7563 0.411422 14.0007 0.0780002C15.2446 -0.255311 16.5321 0.510116 16.8756 1.79189L17.5465 4.29561C24.2818 3.5199 30.8486 7.12995 34.0169 13.2274ZM28.9073 55.7088C32.9891 54.6151 35.6021 50.7075 35.3252 46.536L18.7628 50.9739C20.6084 54.725 24.8251 56.8027 28.9073 55.7088ZM0.413597 52.5989C-0.137865 53.1504 -0.137866 54.0445 0.413597 54.5959C0.965059 55.1474 1.85916 55.1474 2.41062 54.5959L42.9355 14.071C43.487 13.5195 43.487 12.6254 42.9355 12.074C42.3841 11.5225 41.49 11.5225 40.9385 12.074L0.413597 52.5989Z",
    fill: "#5495C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedbell);
export default __webpack_public_path__ + "static/media/crossedbell.31b0d7ec.svg";
export { ForwardRef as ReactComponent };